/* eslint-disable sonarjs/no-duplicate-string */
/**
 * @constant
 */
export const PAGES = {
  LOGIN: '/login',
  HOME: '/',
  MAIN: '/app',
  ADMIN_USERS_VIEW: '/app/admin_users',
  ADMIN_ROLES_VIEW: '/app/admin_roles',
  MY_PROFILE: '/app/profile',
  EVENTS: '/app/soccer/events',
  TENNIS_EVENTS_VIEW: '/app/tennis/tennis-events',
  MATCH_TIMELINE: '/app/soccer/events/match-timeline',
  MATCH_TIMELINE_HISTORY: '/app/soccer/historical-events/match-timeline',
  TENNIS_MATCH_TIMELINE: '/app/tennis/tennis-events/tennis-match-timeline',
  ODDS_HISTORY_STEP_1: '/app/soccer/events/odds-history-step-1',
  TENNIS_ODDS_HISTORY_STEP_1: '/app/tennis/tennis-events/tennis-odds-history-step-1',
  ODDS_HISTORY_STEP_2: '/app/soccer/events/odds-history-step-2',
  TENNIS_ODDS_HISTORY_STEP_2: '/app/tennis/tennis-events/tennis-odds-history-step-2',
  RESULTS: '/app/soccer/results',
  AUTO_BOOKING: '/app/soccer/auto-booking',
  TENNIS_AUTO_BOOKING: '/app/tennis/tennis-auto-booking',
  FEED_SETTINGS: '/app/soccer/settings/feed-settings',
  TENNIS_FEED_SETTINGS: '/app/tennis/tennis-settings/tennis-feed-settings',
  MARKET_SETTINGS: '/app/soccer/settings/market-settings',
  TENNIS_MARKET_SETTINGS: '/app/tennis/tennis-settings/tennis-market-settings',
  MARKET_MARGINS: '/app/soccer/settings/market-margins',
  TENNIS_MARKET_MARGINS: '/app/tennis/tennis-settings/tennis-market-margins',
  EARLY_PAYOUT_CONFIG: '/app/soccer/settings/early-payout-config',
  GOLDEN_GOAL_SETTNGS: '/app/soccer/settings/golden-goal-settings',
  PREMATCH_MARKET: '/app/soccer/settings/prematch-market-settings',
  TEAMS: '/app/soccer/teams',
  LIVE_TEMPLATE: '/app/soccer/live-template',
  TENNIS_LIVE_TEMPLATE: '/app/tennis/live-template',
  PLAYERS_TEMPLATE: '/app/soccer/players-template',
  PLAYERS_TEMPLATE_FILE: '/app/soccer/players-template-file',
  LIVE_SCORE_STATUS: '/app/tennis/tennis-live-score-status',
  TENNIS_LIVE_TEMPLATE_FILE: '/app/tennis/live-template-file',
  LIVE_TEMPLATE_FILE: '/app/soccer/live-template-file',
  SOCCER_HISTORICAL_EVENTS: '/app/soccer/historical-events',
  FEATURES_FLAG: '/app/soccer/settings/features-flag',
  CONFIGURATION_SETTINGS: '/app/soccer/settings/configurations',
};

export const PATHS = {
  LOGIN: '/login',
  HOME: '/',
  MAIN: '/app',
  ADMIN_USERS_VIEW: 'admin_users',
  ADMIN_ROLES_VIEW: 'admin_roles',
  MY_PROFILE: 'profile',
  EVENTS: 'soccer/events',
  TENNIS_EVENTS_VIEW: 'tennis/tennis-events',
  MATCH_TIMELINE: 'soccer/events/match-timeline/*',
  MATCH_TIMELINE_HISTORY: 'soccer/historical-events/match-timeline',
  TENNIS_MATCH_TIMELINE: 'tennis/tennis-events/tennis-match-timeline/*',
  ODDS_HISTORY_STEP_1: 'soccer/events/odds-history-step-1/*',
  TENNIS_ODDS_HISTORY_STEP_1: 'tennis/tennis-events/tennis-odds-history-step-1/*',
  ODDS_HISTORY_STEP_2: 'soccer/events/odds-history-step-2/*',
  TENNIS_ODDS_HISTORY_STEP_2: 'tennis/tennis-events/tennis-odds-history-step-2/*',
  RESULTS: 'soccer/results',
  AUTO_BOOKING: 'soccer/auto-booking',
  TENNIS_AUTO_BOOKING: 'tennis/tennis-auto-booking',
  FEED_SETTINGS: 'soccer/settings/feed-settings',
  TENNIS_FEED_SETTINGS: 'tennis/tennis-settings/tennis-feed-settings',
  MARKET_SETTINGS: 'soccer/settings/market-settings',
  TENNIS_MARKET_SETTINGS: 'tennis/tennis-settings/tennis-market-settings',
  MARKET_MARGINS: 'soccer/settings/market-margins',
  TENNIS_MARKET_MARGINS: 'tennis/tennis-settings/tennis-market-margins',
  EARLY_PAYOUT_CONFIG: 'soccer/settings/early-payout-config',
  GOLDEN_GOAL_SETTNGS: 'soccer/settings/golden-goal-settings',
  PREMATCH_MARKET: 'soccer/settings/prematch-market-settings',
  TEAMS: 'soccer/teams',
  LIVE_TEMPLATE: 'soccer/live-template',
  TENNIS_LIVE_TEMPLATE: 'tennis/live-template',
  PLAYERS_TEMPLATE: 'soccer/players-template',
  PLAYERS_TEMPLATE_FILE: 'soccer/players-template-file',
  LIVE_SCORE_STATUS: 'tennis/tennis-live-score-status',
  TENNIS_LIVE_TEMPLATE_FILE: 'tennis/live-template-file',
  LIVE_TEMPLATE_FILE: 'soccer/live-template-file',
  SOCCER_HISTORICAL_EVENTS: 'soccer/historical-events',
  FEATURES_FLAG: 'soccer/settings/features-flag',
  CONFIGURATION_SETTINGS: 'soccer/settings/configurations',
};

export const COLOMBIA_SKIN = 'colombia';
export const SKIN = process.env.SKIN;

/**
 * @constant
 */
export const MENU = {
  SOCCER: {
    key: 'soccer',
    name: 'Soccer',
    permission: 'EVENTS_VIEW',
  },
  TENNIS: {
    key: 'tennis',
    name: 'Tennis',
    permission: 'TENNIS_EVENTS_VIEW',
  },
  ADMIN: {
    key: 'admin',
    name: 'Admin',
    permission: 'ADMIN_USERS_VIEW',
  },
};

/**
 * list of menu
 * @constant
 */
export const MENU_ROUTES = SKIN === COLOMBIA_SKIN ? [
  'SOCCER', 'ADMIN',
] : [
  'SOCCER', 'TENNIS', 'ADMIN',
];

export const TENNIS_ROUTE = 'TENNIS';

/**
 * list of menu level 2
 * @constant
 */
export const SUBMENU_ITEMS = {
  SETTINGS: {
    FEEDSETTINGS_FEEDPUSHER_LIST: {
      name: 'Feed Settings',
      path: PAGES.FEED_SETTINGS,
    },
    MARKETSETTINGS_MAINMARKETS_VIEW: {
      name: 'Market Settings',
      path: PAGES.MARKET_SETTINGS,
    },
    MARKET_MARGINS_VIEW: {
      name: 'Market Margins',
      path: PAGES.MARKET_MARGINS,
    },
    EARLY_PAYOUT_CONFIG_VIEW: {
      name: 'Early Payout Settings',
      path: PAGES.EARLY_PAYOUT_CONFIG,
    },
    GOLDEN_GOAL_CONFIG_VIEW: {
      name: 'Golden Goal Settings',
      path: PAGES.GOLDEN_GOAL_SETTNGS,
    },
    PREMATCH_MARKET_VIEW: {
      name: 'Prematch Market Settings',
      path: PAGES.PREMATCH_MARKET,
    },
    FEATURES_FLAG_VIEW: {
      name: 'Feature Flag Settings',
      path: PAGES.FEATURES_FLAG,
    },
    CONFIGURATION_SETTINGS_VIEW: {
      name: 'Configuration Settings',
      path: PAGES.CONFIGURATION_SETTINGS,
    },
  },
  TENNIS_SETTINGS: {
    TENNIS_FEED_SETTINGS_VIEW: {
      name: 'Feed Settings',
      path: PAGES.TENNIS_FEED_SETTINGS,
      titlePage: 'Tennis Feed Settings',
    },
    TENNIS_MARKET_SETTINGS_VIEW: {
      name: 'Market Settings',
      path: PAGES.TENNIS_MARKET_SETTINGS,
    },
    TENNIS_MARKET_MARGINS_VIEW: {
      name: 'Market Margins',
      path: PAGES.TENNIS_MARKET_MARGINS,
    },
  },
};
/**
 * list of menu level 1 , key has to be in upper case
 * @constant
 */
export const MENU_ITEMS = {
  TENNIS: {
    TENNIS_EVENTS_VIEW: {
      key: 'TENNIS_EVENTS',
      name: 'Events',
      path: PAGES.TENNIS_EVENTS_VIEW,
    },
    TENNIS_AUTOBOOKING_INTERVAL_VIEW: {
      key: 'TENNIS_AUTO_BOOKING',
      name: 'Autobooking',
      titlePage: 'Autobooking Tennis',
      path: PAGES.TENNIS_AUTO_BOOKING,
    },
    TENNIS_LIVE_SCORE_STATUS_VIEW: {
      key: 'TENNIS_LIVE_SCORE_STATUS',
      name: 'Livescore Status',
      path: PAGES.LIVE_SCORE_STATUS,
    },
    TENNIS_LIVE_TEMPLATE_FILES_VIEW: {
      key: 'TENNIS_LIVE_TEMPLATE_FILE',
      name: 'Live Template Files',
      titlePage: 'Tennis Live Template Files',
      path: PAGES.TENNIS_LIVE_TEMPLATE_FILE,
    },
    TENNIS_LIVE_TEMPLATE_VIEW: {
      key: 'TENNIS_LIVE_TEMPLATE',
      name: 'Live Template',
      titlePage: 'Tennis Live Template',
      path: PAGES.TENNIS_LIVE_TEMPLATE,
    },
    TENNIS_SETTINGS: {
      key: 'TENNIS_SETTINGS',
      name: 'Settings',
    },
  },
  SOCCER: {
    EVENTS_VIEW: {
      key: 'EVENTS',
      name: 'Events',
      path: PAGES.EVENTS,
    },
    HISTORICAL_EVENTS_VIEW: {
      key: 'HISTORICAL_EVENTS',
      name: 'Historical Events',
      path: PAGES.SOCCER_HISTORICAL_EVENTS,
    },
    RESULT_VIEW: {
      key: 'RESULTS',
      name: 'Results',
      path: PAGES.RESULTS,
    },
    AUTOBOOKING_INTERVAL_VIEW: {
      key: 'AUTO_BOOKING',
      name: 'Autobooking ',
      titlePage: 'Autobooking Soccer',
      path: PAGES.AUTO_BOOKING,
    },
    GOALSCORER_COMPETITORS_VIEW: {
      key: 'TEAMS',
      name: 'Teams',
      path: PAGES.TEAMS,
    },
    PLAYER_TEMPLATES_FILES_VIEW: {
      key: 'PLAYERS_TEMPLATE_FILE',
      name: 'Players Template Files',
      path: PAGES.PLAYERS_TEMPLATE_FILE,
    },
    PLAYER_TEMPLATES_VIEW: {
      key: 'PLAYERS_TEMPLATE',
      name: 'Players Template',
      path: PAGES.PLAYERS_TEMPLATE,
    },
    LIVE_TEMPLATES_FILES_VIEW: {
      key: 'LIVE_TEMPLATE_FILE',
      name: 'Live Template Files',
      path: PAGES.LIVE_TEMPLATE_FILE,
    },
    LIVE_TEMPLATES_VIEW: {
      key: 'LIVE_TEMPLATE',
      name: 'Live Template ',
      path: PAGES.LIVE_TEMPLATE,
    },

    SETTINGS: {
      key: 'SETTINGS',
      name: 'Settings',
    },
  },
  ADMIN: {
    ADMIN_USERS_VIEW: {
      key: 'USERS',
      name: 'Users',
      path: PAGES.ADMIN_USERS_VIEW,
    },
    ADMIN_ROLES_VIEW: {
      key: 'ROLES',
      name: 'Roles',
      path: PAGES.ADMIN_ROLES_VIEW,
    },
  },

  PROFILE: {
    MY_PROFILE: {
      name: 'My Profile',
      path: PAGES.MY_PROFILE,
    },
  },
  EVENTS: {
    ODDS_HISTORY_STEP_1: {
      name: 'Odds History Step 1',
      path: PAGES.ODDS_HISTORY_STEP_1,
    },
    ODDS_HISTORY_STEP_2: {
      name: 'Odds History Step 2',
      path: PAGES.ODDS_HISTORY_STEP_2,
    },
    MATCH_TIMELINE: {
      name: 'Match Timeline',
      path: PAGES.MATCH_TIMELINE,
    },
  },
  TENNIS_EVENTS: {
    TENNIS_ODDS_HISTORY_STEP_1: {
      name: 'Tennis Odds History Step 1',
      path: PAGES.TENNIS_ODDS_HISTORY_STEP_1,
    },
    TENNIS_ODDS_HISTORY_STEP_2: {
      name: 'Tennis Odds History Step 2',
      path: PAGES.TENNIS_ODDS_HISTORY_STEP_2,
    },
    TENNIS_MATCH_TIMELINE: {
      name: 'Match Timeline',
      path: PAGES.TENNIS_MATCH_TIMELINE,
    },
  },
};

/**
 * @constant
 */
export const MENU_ICONS = {
  ADMIN: 'user',
  RESULTS: 'result',
  EVENTS: 'calendar',
  HISTORICAL_EVENTS: 'calendar',
  AUTO_BOOKING: 'booking',
  TENNIS_AUTO_BOOKING: 'booking',
  SETTINGS: 'setting',
  TENNIS_SETTINGS: 'setting',
  MARKET_SETTINGS: 'coupon',
  TEAMS: 'team',
  PLAYERS_TEMPLATE: 'team',
  PLAYERS_TEMPLATE_FILE: 'team',
  USERS: 'users',
  ROLES: 'roles',
  TENNIS: 'tennis',
  TENNIS_EVENTS: 'calendar',
  SOCCER: 'soccer',
  TENNIS_LIVE_SCORE_STATUS: 'setting',
  TENNIS_LIVE_TEMPLATE: 'team',
  TENNIS_LIVE_TEMPLATE_FILE: 'team',
  LIVE_TEMPLATE_FILE: 'team',
  LIVE_TEMPLATE: 'team',
};

export const MENU_TYPES = {
  HOME_MENU: 'home__menu',
  DASHBOARD_MENU: 'side-nav',
};

/**
 *  @constant
 */
const API_PATH = process.env.NODE_ENV === 'development' ? '/zoombackofficeapi/' : process.env.API_URL;

/**
 * @constant
 */
export const API_URLS = {
  INIT: `${API_PATH}App/Init`,
  INIT_TENNIS: `${API_PATH}tennis/App/InitTennis`,
  LOGIN: `${API_PATH}Session/Login`,
  LOGOUT: `${API_PATH}Session/Logout`,
  USER_LIST: `${API_PATH}User/GetUserList`,
  USER_ADD: `${API_PATH}User/CreateNewUser`,
  USER_REMOVE: `${API_PATH}User/DeleteUser`,
  USER_RESET_PASS: `${API_PATH}User/ResetUserPassword`,
  USER_EDIT_ROLES: `${API_PATH}User/EditUserRoles`,
  USER_EDIT_STATUS: `${API_PATH}User/UpdateUserStatus`,
  USER_EDIT_INFO: `${API_PATH}User/EditUserInfo`,
  ROLES: `${API_PATH}Role/GetRoleList`,
  DISABLE_ENABLE_ROLE: `${API_PATH}Role/UpdateRoleStatus`,
  PERMISSIONS: `${API_PATH}Permission/GetPermissionList`,
  PROFILE_INFO: `${API_PATH}Account/GetUserDetails`,
  CHANGE_USER_PWD: `${API_PATH}Account/ChangePassword`,
  SAVE_NEW_ROLE: `${API_PATH}Role/CreateNewRole`,
  SAVE_EDIT_ROLE: `${API_PATH}Role/EditRole`,
  REMOVE_ROLE: `${API_PATH}Role/DeleteRole`,
  ROLE_PERMISSION: `${API_PATH}Permission/GetRolePermissions`,
  DOWNLOAD_EXCEL_FILE: `${API_PATH}Event/GetOddsExcel`,
  DOWNLOAD_TENNIS_EXCEL_FILE: `${API_PATH}tennis/TennisEvents/GetOddsExcel`,
  GET_EVENTS: `${API_PATH}Event/GetEventsList`,
  GET_TENNIS_EVENTS: `${API_PATH}tennis/TennisEvents/GetEventsList`,
  BOOK_EVENTS: `${API_PATH}Event/BookEvents`,
  UNBOOK_EVENTS: `${API_PATH}Event/UnbookEvents`,
  BOOK_TENNIS_EVENTS: `${API_PATH}tennis/TennisEvents/BookEvents`,
  UNBOOK_TENNIS_EVENTS: `${API_PATH}tennis/TennisEvents/UnbookEvents`,
  GET_INTERVALS: `${API_PATH}Autobooking/GetIntervals`,
  GET_TENNIS_INTERVALS: `${API_PATH}tennis/TennisAutobooking/GetIntervals`,
  SAVE_CHANGES: `${API_PATH}Autobooking/SetIntervals`,
  SAVE_TENNIS_CHANGES: `${API_PATH}tennis/TennisAutobooking/SetIntervals`,
  GET_MATCH_TIMELINE: `${API_PATH}Event/GetMatchTimeline`,
  GET_MATCH_TIMELINE_HISTORY: `${API_PATH}Event/GetMatchTimelineHistory`,
  GET_TENNIS_MATCH_TIMELINE: `${API_PATH}tennis/TennisEvents/GetMatchTimeline`,
  GET_ODDS_DETAILS: `${API_PATH}Event/GetOddsDetails`,
  GET_TENNIS_ODDS_DETAILS: `${API_PATH}tennis/TennisEvents/GetOddsDetails`,
  GET_FEED_SETTINGS: `${API_PATH}FeedSettings/GetFeedPusherSettings`,
  GET_TENNIS_FEED_SETTINGS: `${API_PATH}tennis/TennisFeedPusherStatus/GetFeedPusherStatus`,

  UPDATE_FEED_STATUS: `${API_PATH}FeedSettings/SetFeedPusherSettings`,
  UPDATE_ODDS_STATUS: `${API_PATH}FeedSettings/SetInvalidateOdds`,

  UPDATE_TENNIS_FEED_STATUS: `${API_PATH}tennis/TennisFeedPusherStatus/SetFeedPusherStatus`,
  UPDATE_TENNIS_ODDS_STATUS: `${API_PATH}tennis/TennisFeedPusherStatus/SetFeedPusherInvalidateOdds`,

  GET_MARKET_SETTINGS: `${API_PATH}MarketSettings/GetMainMarketSettings`,
  GET_TENNIS_MARKET_SETTINGS: `${API_PATH}tennis/TennisMarketSettings/GetMainMarketSettings`,
  UPDATE_MARKET_SETTINGS_ODDS_STATUS: `${API_PATH}MarketSettings/UpdateOddsDisable`,
  UPDATE_TENNIS_MARKET_SETTINGS_ODDS_STATUS: `${API_PATH}tennis/TennisMarketSettings/UpdateOddsDisable`,
  UPDATE_MARKET_SETTINGS_RESULTS_STATUS: `${API_PATH}MarketSettings/UpdateResultsDisable`,
  UPDATE_TENNIS_MARKET_SETTINGS_RESULTS_STATUS: `${API_PATH}tennis/TennisMarketSettings/UpdateResultsDisable`,

  GET_COMPETITORS: `${API_PATH}GoalScorer/GetCompetitors`,
  GET_PLAYERS: `${API_PATH}GoalScorer/GetPlayers`,
  SAVE_NEW_PLAYER: `${API_PATH}GoalScorer/CreatePlayer`,
  DISABLE_PLAYER: `${API_PATH}GoalScorer/DisablePlayer`,
  SAVE_UPDATED_SQUAD: `${API_PATH}GoalScorer/UpdateSquad`,
  GET_PLAYERS_TEMPLATE: `${API_PATH}Team/GetPlayerTemplates`,
  SAVE_PLAYERS_TEMPLATE: `${API_PATH}Team/ApplyPlayerTemplate`,
  GET_PLAYERS_TEMPLATE_FILE: `${API_PATH}Team/GetPlayerTemplateFiles`,
  SAVE_PLAYERS_TEMPLATE_FILE: `${API_PATH}Team/UploadPlayerTemplate`,
  SAVE_PLAYERS_TEMPLATE_PREVIEW: `${API_PATH}Team/PreviewApplyPlayerTemplate`,
  DOWNLOAD_PLAYERS_TEMPLATE_FILE: `${API_PATH}Team/DownloadPlayerTemplates`,
  GET_LIVE_TEMPLATE: `${API_PATH}LiveTemplates/GetLiveTemplates`,
  GET_TENNIS_LIVE_TEMPLATE: `${API_PATH}tennis/TennisLiveTemplates/GetLiveTemplates`,
  SAVE_LIVE_TEMPLATE: `${API_PATH}LiveTemplates/ApplyLiveTemplate`,
  SAVE_TENNIS_LIVE_TEMPLATE: `${API_PATH}tennis/TennisLiveTemplates/ApplyLiveTemplate`,
  GET_LIVE_TEMPLATE_FILE: `${API_PATH}LiveTemplates/GetLiveTemplateFiles`,
  GET_TENNIS_LIVE_TEMPLATE_FILE: `${API_PATH}tennis/TennisLiveTemplateFiles/GetLiveTemplateFiles`,
  SAVE_LIVE_TEMPLATE_FILE: `${API_PATH}LiveTemplates/UploadLiveTemplateFile`,
  SAVE_TENNIS_LIVE_TEMPLATE_FILE: `${API_PATH}tennis/TennisLiveTemplateFiles/UploadLiveTemplateFile`,
  DOWNLOAD_TENNIS_LIVE_TEMPLATE_FILE: `${API_PATH}tennis/TennisLiveTemplateFiles/DownloadLiveTemplateFile`,
  DOWNLOAD_LIVE_TEMPLATE_FILE: `${API_PATH}LiveTemplates/DownloadLiveTemplate`,

  GET_MARKET_MARGINS: `${API_PATH}MarketMargins/GetMarketMargins`,
  UPDATE_MARKET_MARGINS: `${API_PATH}MarketMargins/UpdateMarketMargins`,

  GET_TENNIS_MARKET_MARGINS: `${API_PATH}tennis/TennisMarketMargins/GetMarketMargins`,
  UPDATE_TENNIS_MARKET_MARGINS: `${API_PATH}tennis/TennisMarketMargins/UpdateMarketMargins`,

  GET_EARLY_PAYOUT_SETTINGS: `${API_PATH}EarlyPayoutConfiguration/GetEarlyPayoutConfiguration`,
  UPDATE_EARLY_PAYOUT_SETTINGS: `${API_PATH}EarlyPayoutConfiguration/UpdateEarlyPayoutConfiguration`,

  GET_GOLDEN_GOAL_SETTINGS: `${API_PATH}GoldenGoalConfiguration/GetGoldenGoalConfiguration`,
  UPDATE_GOLDEN_GOAL_SETTINGS: `${API_PATH}GoldenGoalConfiguration/UpdateGoldenGoalConfiguration`,

  GET_LIVE_SCORE_STATUS: `${API_PATH}tennis/TennisLiveScoreStatus/GetLiveScoreStatus`,
  UPDATE_LIVE_SCORE_STATUS: `${API_PATH}tennis/TennisLiveScoreStatus/SetLiveScoreStatus`,

  GET_HISTORICAL_EVENTS: `${API_PATH}Event/GetHistoryEventList`,
  GET_PREMATCH_MARKET: `${API_PATH}PrematchMarketSettings/GetPrematchMarketSettings`,
  UPDATE_PREMATCH_MARKET: `${API_PATH}PrematchMarketSettings/UpdatePrematchMarketSettings`,

  GET_FEATURES_FLAG: `${API_PATH}FeatureFlagSettings/GetFeatureFlagSettings`,
  UPDATE_FEATURES_FLAG: `${API_PATH}FeatureFlagSettings/UpdateFeatureFlagSettings`,

  GET_CONFIGURATION_SETTINGS: `${API_PATH}Config/GetConfigList`,
  UPDATE_MAX_ODDS_CAP_SETTINGS: `${API_PATH}Config/UpdateConfig`,
};

/**
 * @constant
 */
const IMG_PATH = '/img/responsive';

/**
 * @param {string|null} cnt
 * @returns {string}
 */
export const CNT_PATH = (cnt) => (process.env.NODE_ENV === 'development' ? IMG_PATH : cnt);

/**
 * @constant
 */
export const SVG_ICONS = {
  homeIcons: 'home-icons.svg',
  pagination: 'pagination-arrow.svg',
  utility: 'utility-icon.svg',
  switchArrowIcons: 'switch-arrow.svg',
};

/**
 * @constant
 */
export const MODALS = {
  USER_ADD: 'MODAL@@USER_ADD',
  USER_CONFIRM: 'MODAL@@USER_CONFIRM',
  USER_EDIT: 'MODAL@@USER_EDIT',
  SUCCESS: 'MODAL@SUCCESS',
  ERROR: 'Error',
  SESSION_EXPIRED: 'Session Expired',
  GENERAL_ERROR: 'Something went wrong!',
  USER_PWD_CHANGE: 'MODAL@@USER_PWD_CHANGE',
  USER_INFO_EDIT: 'MODAL@@USER_INFO_EDIT',
  AUTO_BOOKING: 'MODAL@@AUTO_BOOKING',
  EVENT_SELECTION: 'MODAL@@EVENT_SELECTION',
  DELETE_INTERVAL: 'MODAL@@DELETE_INTERVAL',
  SAVE_INTERVAL: 'MODAL@@SAVE_INTERVAL',
  SAVE_BEFORE_NAVIGATION: 'MODAL@@SAVE_BEFORE_NAVIGATION',
  TEAM_DETAILS: 'MODAL@@TEAM_DETAILS',
  MARKET_MARGINS_CHANGE: 'MODAL@@MARKET_MARGINS_CHANGE',
  PLAYERS_TEMPLATE_ADD: 'MODAL@@PLAYERS_TEMPLATE_ADD',
  LIVE_TEMPLATE_ADD: 'MODAL@@LIVE_TEMPLATE_ADD',
  TENNIS_LIVE_TEMPLATE_ADD: 'MODAL@@TENNIS_LIVE_TEMPLATE_ADD',
  PLAYERS_TEMPLATE_ADD_PREVIEW: 'MODAL@@PLAYERS_TEMPLATE_ADD_PREVIEW',
  INFORMATION_MSG: 'MODAL@@INFORMATION_MSG',
};

/**
 * @constant
 */
export const SUCCESS_MODALS = {
  RESET_PASSWORD: 'Reset Password',
  EDIT_ROLES: 'Edit roles',
  EDIT_STATUS: 'Edit status',
  EDIT_INFO: 'Edit User',
  REMOVE_USER: 'Remove user',
  REMOVE_ROLE: 'Remove role',
  ADD_USER: 'Add user',
  ADD_ROLE: 'Add role',
  CHANGE_USER_PWD: 'Password change',
  INTERVALS_CHANGE: 'Intervals change',
  UPDATE_EARLY_PAYOUT_SETTINGS: 'Early Payout Settings updated',
  UPDATE_GOLDEN_GOAL_SETTINGS: 'Golden Goal Settings for ',
  UPDATE_MARKET_MARGINS_SETTINGS: 'Market Margins Settings updated',
  UPDATE_TENNIS_MARKET_MARGINS_SETTINGS: 'Market Margins Settings for tennis updated',
  UPLOAD_PLAYERS_TEMPLATES_FILE: 'Players Template File uploaded successfully',
  SAVE_PLAYERS_TEMPLATE: 'Players Template inserted successfully',
  UPDATE_LIVE_SCORE_STATUS: 'Livescore status updated',
  SAVE_LIVE_TEMPLATE: 'Live Template inserted successfully',
  UPLOAD_LIVE_TEMPLATES_FILE: 'Live Template File uploaded successfully',
  UPDATE_FEATURES_FLAG: 'Features flag updated successfully',
  CONFIGURATION_SETTINGS: 'Configuration settings updated',
};

/**
 * @constant
 */
export const ERRORS = {
  SESSION_EXPIRED: -30101,
  AUTH_REQUIRED: -30102,
};

/**
 * @constant
 */
export const PERMISSIONS = {
  ADMIN_USERS_VIEW: 100100,
  ADMIN_USERS_ADD: 100101,
  ADMIN_USERS_ROLES: 100102,
  ADMIN_USERS_RESET_PASSWORD: 100103,
  ADMIN_USERS_UPDATE: 100104,
  ADMIN_USERS_ENABLE: 100105,
  ADMIN_USERS_DELETE: 100106,
  ADMIN_ROLES_VIEW: 100200,
  ADMIN_ROLES_ADD: 100201,
  ADMIN_ROLES_UPDATE: 100202,
  ADMIN_ROLES_REMOVE: 100203,
  ADMIN_ROLES_DISABLE_ENABLE: 100204,
  ADMIN_ROLES_LIST_PERMISSION: 100205,
  ADMIN_PERMISSIONS_VIEW: 100300,
  PROFILE_VIEW: 110100,
  PROFILE_PASSWORD_UPDATE: 110101,
  EVENTS_VIEW: 120100,
  HISTORICAL_EVENTS_VIEW: 120100,
  EVENTS_BOOK_UNBOOK: 120101,
  TIMELINE_VIEW: 130100,
  ODDS_HISTORY_VIEW: 140100,
  ODDS_HISTORY_EXCEL_EXPORT: 140101,
  AUTOBOOKING_INTERVAL_VIEW: 150100,
  AUTOBOOKING_INTERVAL_UPDATE: 150102,
  TENNIS_AUTOBOOKING_INTERVAL_VIEW: 240104,
  TENNIS_AUTOBOOKING_INTERVAL_UPDATE: 240105,
  RESULT_VIEW: 160100,
  TENNIS_FEED_SETTINGS_VIEW: 240115,
  FEEDSETTINGS_FEEDPUSHER_LIST: 170100,
  FEEDSETTINGS_FEEDPUSHER_UPDATE: 170101,
  FEEDSETTINGS_FEEDPUSHER_INVALIDATE_ODDS: 170102,
  TENNIS_FEED_SETTINGS_UPDATE: 240116,
  TENNIS_FEED_SETTINGS_INVALIDATE_ODDS: 240117,
  MARKETSETTINGS_MAINMARKETS_VIEW: 180100,
  MARKETSETTINGS_MAINMARKETS_ODDS_DISABLE_ENABLE: 180101,
  TENNIS_MARKETSETTINGS_MAINMARKETS_ODDS_DISABLE_ENABLE: 240119,
  MARKETSETTINGS_MAINMARKETS_RESULTS_DISABLE_ENABLE: 180102,
  TENNIS_MARKETSETTINGS_MAINMARKETS_RESULTS_DISABLE_ENABLE: 240120,
  TENNIS_MARKET_SETTINGS_VIEW: 240118,

  GOALSCORER_COMPETITORS_VIEW: 190100,
  GOALSCORER_PLAYERS_VIEW: 190101,
  GOALSCORER_PLAYERS_ADD: 190102,
  GOALSCORER_PLAYERS_DISABLE: 190103,
  GOALSCORER_SQUAD_UPDATE: 190104,

  MARKET_MARGINS_VIEW: 200100,
  MARKET_MARGINS_UPDATE: 200101,
  TENNIS_MARKET_MARGINS_VIEW: 240109,
  TENNIS_MARKET_MARGINS_UPDATE: 240110,
  EARLY_PAYOUT_CONFIG_VIEW: 210100,
  EARLY_PAYOUT_CONFIG_UPDATE: 210101,
  GOLDEN_GOAL_CONFIG_VIEW: 220100,
  GOLDEN_GOAL_CONFIG_UPDATE: 220101,
  PLAYER_TEMPLATES_FILES_VIEW: 230102,
  TEAM_UPLOAD_FILE: 230101,
  PLAYER_TEMPLATES_VIEW: 230100,
  LIVE_TEMPLATES_FILES_VIEW: 250101,
  LIVE_TEMPLATE_UPLOAD: 250100,
  LIVE_TEMPLATES_VIEW: 250102,
  PLAYER_TEMPLATES_ADD: 230103,
  TENNIS_EVENTS_VIEW: 240100,
  SETTINGS: 170100,
  TENNIS_SETTINGS: 240118,
  TENNIS_LIVE_SCORE_STATUS_VIEW: 240107,
  TENNIS_LIVE_SCORE_STATUS_UPDATE: 240108,
  TENNIS_LIVE_TEMPLATE_VIEW: 240113,
  TENNIS_LIVE_TEMPLATES_APPLY: 240114,
  TENNIS_LIVE_TEMPLATE_FILES_VIEW: 240111,
  TENNIS_LIVE_TEMPLATE_FILE_UPLOAD: 240112,
  LIVE_TEMPLATES_APPLY: 250103,
  PREMATCH_MARKET_VIEW: 270100,
  PREMATCH_MARKET_UPDATE: 270101,
  FEATURES_FLAG_VIEW: 280100,
  FEATURES_FLAG_UPDATE: 280101,
  CONFIGURATION_SETTINGS_VIEW: 300100,
  CONFIGURATION_SETTINGS_UPDATE: 300101,
};

/**
 * @constant
 */
export const ROLE_STATUS = {
  1: 'Enabled',
  '-1': 'Disabled',
  ENABLED: 1,
  DISABLED: -1,
};

/**
 * @constant
 */
export const CONFIRM_MODAL_CONTENT = {
  REMOVE_ROLE: {
    title: 'Are you sure you want to remove the selected role?',
    heading: 'Remove role?',
  },
};

export const EVENT_STATUS = {
  0: 'future',
  1: 'pre-match',
  2: 'in-progress',
  3: 'ended',
  '-1': 'skipped',
};
export const EVENT_STATUS_VALUES = {
  FUTURE: 0,
  PRE_MATCH: 1,
  IN_PROGRESS: 2,
  ENDED: 3,
  SKIPPED: -1,
};

export const CLICK_DIRECTIONS = {
  UP: 1,
  DOWN: -1,
};

export const DAYS = {
  1: 'Monday',
  2: 'Tuesday',
  3: 'Wednesday',
  4: 'Thursday',
  5: 'Friday',
  6: 'Saturday',
  7: 'Sunday',
};

export const DAYS_SHORT = {
  1: 'Mon',
  2: 'Tue',
  3: 'Wed',
  4: 'Thu',
  5: 'Fri',
  6: 'Sat',
  7: 'Sun',
};

export const INTERVAL_COLORS = [
  'bg-blue', 'bg-green', 'bg-pale-blue', 'bg-grey',
];

export const BOOKING_TYPE = {
  BOOK: 1,
  UNBOOK: 2,
  1: 'Book',
  2: 'Unbook',
};

export const FETCH_OPTIONS = {
  LOGIN: 'LOGIN',
  LOGOUT: 'LOGOUT',
  USER_LIST: 'USER_LIST',
  USER_ADD: 'USER_ADD',
  USER_REMOVE: 'USER_REMOVE',
  RESET_PASS: 'RESET_PASS',
  EDIT_USER_ROLES: 'EDIT_USER_ROLES',
  EDIT_USER_STATUS: 'EDIT_USER_STATUS',
  EDIT_USER_INFO: 'EDIT_USER_INFO',
  GET_INTERVALS: 'GET_INTERVALS',
  GET_TENNIS_INTERVALS: 'GET_TENNIS_INTERVALS',
  SET_INTERVALS: 'SET_INTERVALS',
  SET_TENNIS_INTERVALS: 'SET_TENNIS_INTERVALS',
  INIT: 'INIT',
  INIT_TENNIS: 'INIT_TENNIS',
  GET_PROFILE_INFO: 'GET_PROFILE_INFO',
  CHANGE_PASS: 'CHANGE_PASS',
  GET_EVENTS: 'GET_EVENTS',
  GET_TENNIS_EVENTS: 'GET_TENNIS_EVENTS',
  BOOK: 'BOOK',
  UNBOOK: 'UNBOOK',
  BOOK_TENNIS: 'BOOK_TENNIS',
  UNBOOK_TENNIS: 'UNBOOK_TENNIS',
  GET_MATCHTIMELINE: 'GET_MATCHTIMELINE',
  GET_TENNIS_MATCHTIMELINE: 'GET_TENNIS_MATCHTIMELINE',
  GET_ODDS_HISTORY: 'GET_ODDS_HISTORY',
  GET_TENNIS_ODDS_HISTORY: 'GET_TENNIS_ODDS_HISTORY',
  GET_EXCEL_FILE: 'GET_EXCEL_FILE',
  GET_TENNIS_EXCEL_FILE: 'GET_TENNIS_EXCEL_FILE',
  ROLES_INIT: 'ROLES_INIT',
  GET_PERMISSIONS: 'GET_PERMISSIONS',
  ADD_ROLE: 'ADD_ROLE',
  REMOVE_ROLE: 'REMOVE_ROLE',
  CHANGE_ROLE_STATUS: 'CHANGE_ROLE_STATUS',
  GET_ROLE_PERMISSION: 'GET_ROLE_PERMISSION',
  SAVE_EDIT_ROLE: 'SAVE_EDIT_ROLE',
  GET_FEED_SETTINGS: 'GET_FEED_SETTINGS',
  GET_TENNIS_FEED_SETTINGS: 'GET_TENNIS_FEED_SETTINGS',
  UPDATE_FEED_STATUS: 'UPDATE_FEED_STATUS',
  UPDATE_ODDS_STATUS: 'UPDATE_ODDS_STATUS',
  UPDATE_TENNIS_FEED_STATUS: 'UPDATE_TENNIS_FEED_STATUS',
  UPDATE_TENNIS_ODDS_STATUS: 'UPDATE_TENNIS_ODDS_STATUS',
  GET_MARKET_SETTINGS: 'GET_MARKET_SETTINGS',
  GET_TENNIS_MARKET_SETTINGS: 'GET_TENNIS_MARKET_SETTINGS',
  UPDATE_ODDS_DISABLED_STATUS: 'UPDATE_ODDS_DISABLED_STATUS',
  UPDATE_TENNIS_ODDS_DISABLED_STATUS: 'UPDATE_TENNIS_ODDS_DISABLED_STATUS',
  GET_COMPETITORS: 'GET_COMPETITORS',
  GET_PLAYERS: 'GET_PLAYERS',
  SAVE_NEW_PLAYER: 'SAVE_NEW_PLAYER',
  DISABLE_PLAYER: 'DISABLE_PLAYER',
  SAVE_UPDATED_SQUAD: 'SAVE_UPDATED_SQUAD',
  GET_MARKET_MARGINS: 'GET_MARKET_MARGINS',
  GET_TENNIS_MARKET_MARGINS: 'GET_TENNIS_MARKET_MARGINS',
  UPDATE_MARKET_MARGINS: 'UPDATE_MARKET_MARGINS',
  UPDATE_TENNIS_MARKET_MARGINS: 'UPDATE_TENNIS_MARKET_MARGINS',
  GET_EARLY_PAYOUT_SETTINGS: 'GET_EARLY_PAYOUT_SETTINGS',
  UPDATE_EARLY_PAYOUT_SETTINGS: 'UPDATE_EARLY_PAYOUT_SETTINGS',
  GET_GOLDEN_GOAL_SETTINGS: 'GET_GOLDEN_GOAL_SETTINGS',
  UPDATE_GOLDEN_GOAL_SETTINGS: 'UPDATE_GOLDEN_GOAL_SETTINGS',
  PLAYERS_TEMPLATE: 'PLAYERS_TEMPLATE',
  SAVE_PLAYERS_TEMPLATE: 'SAVE_PLAYERS_TEMPLATE',
  PLAYERS_TEMPLATE_FILE: 'PLAYERS_TEMPLATE_FILE',
  SAVE_PLAYERS_TEMPLATE_FILE: 'SAVE_PLAYERS_TEMPLATE_FILE',
  SAVE_PLAYERS_TEMPLATE_PREVIEW: 'SAVE_PLAYERS_TEMPLATE_PREVIEW',
  DOWNLOAD_PLAYERS_TEMPLATE_FILE: 'DOWNLOAD_PLAYERS_TEMPLATE_FILE',
  GET_LIVE_SCORE_STATUS: 'GET_LIVE_SCORE_STATUS',
  UPDATE_LIVE_SCORE_STATUS: 'UPDATE_LIVE_SCORE_STATUS',
  LIVE_TEMPLATE_FILE: 'LIVE_TEMPLATE_FILE',
  LIVE_TEMPLATE: 'LIVE_TEMPLATE',
  SAVE_LIVE_TEMPLATE: 'SAVE_LIVE_TEMPLATE',
  TENNIS_LIVE_TEMPLATE: 'TENNIS_LIVE_TEMPLATE',
  SAVE_TENNIS_LIVE_TEMPLATE: 'SAVE_TENNIS_LIVE_TEMPLATE',
  SAVE_TENNIS_LIVE_TEMPLATE_FILE: 'SAVE_TENNIS_LIVE_TEMPLATE_FILE',
  SAVE_LIVE_TEMPLATE_FILE: 'SAVE_LIVE_TEMPLATE_FILE',
  DOWNLOAD_TENNIS_LIVE_TEMPLATE_FILE: 'DOWNLOAD_TENNIS_LIVE_TEMPLATE_FILE',
  DOWNLOAD_LIVE_TEMPLATE_FILE: 'DOWNLOAD_LIVE_TEMPLATE_FILE',
  UPDATE_RESULTS_DISABLED_STATUS: 'UPDATE_RESULTS_DISABLED_STATUS',
  UPDATE_TENNIS_RESULTS_DISABLED_STATUS: 'UPDATE_TENNIS_RESULTS_DISABLED_STATUS',
  GET_HISTORICAL_EVENTS: 'GET_HISTORICAL_EVENTS',
  GET_PREMATCH_MARKET: 'GET_PREMATCH_MARKET',
  UPDATE_PREMATCH_MARKET: 'UPDATE_PREMATCH_MARKET',
  GET_FEATURES_FLAG: 'GET_FEATURES_FLAG',
  UPDATE_FEATURES_FLAG: 'UPDATE_FEATURES_FLAG',
  GET_CONFIGURATION_SETTINGS: 'GET_CONFIGURATION_SETTINGS',
  UPDATE_CONFIGURATION_SETTINGS: 'UPDATE_CONFIGURATION_SETTINGS',
};

export const ZOOM_URL = process.env.ZOOM_URL;

export const SHOW_FILTERS = {
  ALL: -100,
  ONLY_BOOKED: 1,
  ONLY_AVAILABLE: 2,
};

export const FEED_PUSHER_SETTING = {
  FEED_STATUS: {
    1: 'Active',
    '-1': 'All Disabled',
    '-2': 'Odd Disabled',
    ACTIVE: 1,
    'ALL DISABLED': -1,
    'ODD DISABLED': -2,
  },

  INVALIDATE_ODDS: {
    1: 'Yes',
    '-1': 'Enabled Manually',
    0: 'No',
    ENABLED_MANUALLY: -1,
    NO: 0,
  },
};

export const MARKET_SETTINGS = {
  ODDS: {
    ACTIVE: 0,
    DISABLED: 1,
    0: 'Active',
    1: 'Disabled',
  },

  RESULTS: {
    ACTIVE: 0,
    DISABLED: 1,
    0: 'Active',
    1: 'Disabled',
  },
};

export const TIMEZONES = {
  UTC: 'UTC',
  AFR: 'Africa/Lagos',
  EU: 'Europe/Rome',
};

export const TIMEZONE_KEY_IN_LS = 'timezone';

export const MARKET_ID_102 = 102;
export const MARKET_5MIN_1X2_IDS = [102, 103, 104, 105, 106, 107,
  108, 109, 110, 111, 112, 113, 114, 115, 116, 117];

export const ODDS_HISTORY_MARKET_EXCEPTIONS = [31, 32, 46];

export const MARKET_SETTINGS_TYPES = {
  ODDS: 'Odds',
  RESULTS: 'Results',
};

export const MATCH_STATUS = {
  HT: 'HT',
  FT: 'FT',
};

export const FILTERS_NAMES = {
  MATCH_ID: 'Match ID',
  DATE: 'Date',
  LEAGUE: 'League',
  TEAM_NAME: 'Teams Name',
  SHOW: 'Show',
  HIDE_ENDED_MATCHES: 'Hide Ended Matches',
};

export const TENNIS_FILTERS_NAMES = {
  MATCH_ID: 'Match ID',
  DATE: 'Date',
  COMPETITION: 'Competition',
  PLAYER_NAME: 'Player Name',
  STATUS: 'Status',
  SHOW: 'Booked/Unbooked',
  HIDE_ENDED_MATCHES: 'Hide Ended Matches',
};

export const CALENDAR_FIELDS = {
  FROM: 1,
  TO: 2,
};

/**
 * @constant
 */
export const MANIPULATIONS = {
  RESET_DATE_AND_TIME: 'RESET_DATE_AND_TIME',
};

export const TOTAL_DATES_TO_SHOW = 42;

export const EMPTY_PLAYERS_LIST = new Array(11).fill({
  id: null,
  name: null,
  squad_position: null,
  goal_probability: null,
});

export const MARKET_MARGINS_MODAL_TYPES = {
  ADD: 'Add',
  EDIT: 'Edit',
};

export const ERROR_MESSAGES = {
  MARKET_MARGINS: {
    CANNOT_OVERLAP: 'Market Margin Odds Cannot Overlap',
    MARGIN_RANGE: 'Margin should be between 1 and 2',
    LESS_THAN_1000: 'Market Margin Odds should be less than 1000',
  },
};

export const MARKET_MARGINS_ERROR = {
  '-31007': 'Margins above 1.2 are not allowed',
};

export const GOLDEN_GOAL_SETTINGS_INPUTS = {
  MAX_PROB: 'MAX_PROB',
  WINN_COEFF: 'WINN_COEFF',

};

export const EARLY_PAYOUT_INPUT = {
  ENABLED_DISABLED: 'ENABLED_DISABLED',
  THRESHOLD: 'THRESHOLD',
  MINIMUM_SLOT: 'MINIMUM_SLOT',
};

export const MAX_ALLOWED_ODDS = 1000;

export const MARGIN_ERROR_FIELDS = {
  FROM_ODDS: 'fromOdds',
  MARGINS: 'margins',
};

export const MIN_MARGIN_OVERIDE_THRESHOLD = 98;

export const PLAYERS_TEMPLATES_FILES_TXT = {
  inputLabel: 'No file selected',
  validExtentions: ['xlsx', 'xls'],
  inputErrorMgs: 'Invalid file format - please upload an Excel file',
};

export const PLAYERS_STATUS = {
  updatedPlayers: 'Updated',
  playersToDisable: 'Deleted',
  addedPlayers: 'Added',
};

export const PLAYERS_ID = {
  PLAYER_1: 1,
  PLAYER_2: 2,
};

export const SET_POINT_HOMEWIN_GAMESCORES = ['6:0', '6:1', '6:2', '6:3', '6:4', '7:5'];
export const SET_POINT_HOMEWIN_POINTS = ['40:0', '40:15', '40:30', 'A:40'];
export const SET_POINT_AWAYWIN_GAMESCORES = ['0:6', '1:6', '2:6', '3:6', '4:6', '5:7'];
export const SET_POINT_AWAYWIN_POINTS = ['0:40', '15:40', '30:40', '40:A'];

export const TB_SET_POINT_HOME = ['6:0', '6:1', '6:2', '6:3', '6:4', '6:5'];
export const TB_SET_POINT_AWAY = ['0:6', '1:6', '2:6', '3:6', '4:6', '5:6'];

export const TENNIS_MAX_NB_MATCH = 8;

export const TENNIS_GAME_STEP = {
  s: 'start',
  e: 'end',
};

export const LIVE_SCORE_STATUS = {
  1: 'Active',
  '-1': 'Manually Disabled',
  0: 'Disabled',
  ACTIVE: '1',
  MANUALY_DISABLED: '-1',
  DISABLED: 0,
};

export const FILTER_SHOW_DROPDOWN = [
  { id: SHOW_FILTERS.ALL, label: 'All' },
  { id: 1, label: 'Only Booked' },
  { id: 2, label: 'Only Available' },
];

export const TENNIS_FILTER_SHOW_DROPDOWN = [
  { id: SHOW_FILTERS.ALL, label: 'All' },
  { id: 1, label: 'Booked' },
  { id: 2, label: 'Unbooked' },
];
export const MARKET_TYPES_MATCH = {
  PREMATCH: 1,
  LIVE: 2,
  PREMATCH_LIVE: 3,
};


export const FILTER_FIELDS = {
  FILTER_LEAGUE_ARRAY: 1,
  FILTER_SHOW_RANGE: 4
};

export const TENNIS_FILTER_FIELDS = {
  FILTER_COMP_ARRAY: 1,
  FILTER_STATUS_RANGE: 4,
  FILTER_SHOW_RANGE: 5,
};